"use strict";
exports.__esModule = true;
exports.name = void 0;
var utils_1 = require("../../utils");
var factory_1 = require("../factory");
var validation_1 = require("../validation");
var nameRegex = /^[a-z][a-z0-9_]{0,39}$/;
var name = function (messageKey) { return function (field, obj) {
    var value = utils_1.Objects.path(field)(obj);
    var valid = utils_1.Objects.isEmpty(value) || nameRegex.test(value);
    return factory_1.ValidationResultFactory.createInstance({
        valid: valid,
        messageKey: messageKey,
        severity: validation_1.ValidationSeverity.error
    });
}; };
exports.name = name;
//# sourceMappingURL=name.js.map